import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

import {getUsersByClientPromise} from "../../../../../../promises";
import {getRulesPromise} from "../../../../promises";

import moment from "moment";
import "./AdvancedTabs.scss";

import {
    Button,
    DatePicker,
    Input,
    Select,
    Badge,
    Tooltip,
    Tabs,
    Row,
    Col,
} from "antd";


const AdvancedTabs = ({cbFilters, type, currentUser, filters={}}) => {
    const [users, setUsers] = useState([])
    const [rules, setRules] = useState(null)
    const [advancedObj, setAdvancedObj] = useState(filters);

    const getInitialAdvancedObjMenu = (initialFilters) => {
        const menu = { m1: {}, m2: {}, m3: {}, m4: {} }
        const menuFields = {
            m1: ['rutNombre', 'tipoPersona'],
            m2: ['fechaAlerta', 'folio', 'fechaAsignacion', 'usuarioAsignado'],
            m3: ['tipoRiesgoRules', 'ruleId', 'transactionNumber', 'fechaTransaction'],
            m4: ['hasFP'],
        }
        Object.keys(menuFields).forEach((menuKey) => {
            menuFields[menuKey].forEach((field) => {
                if (initialFilters[field] !== undefined && initialFilters[field] !== null && initialFilters[field] !== '') {
                    menu[menuKey][field] = initialFilters[field]
                }
            })
        })
        return menu
    }

    const [advancedObjMenu, setAdvancedObjMenu] = useState(getInitialAdvancedObjMenu(filters));
    const {TabPane} = Tabs;
    const {t} = useTranslation();

    useEffect(() => {
        getUsersByClientPromise().then((response) => {
            const filtered = []
            response.map(u => {
                if ((u.type === 'ADMIN' || u.type === 'SADMIN' || u.type === 'USUARIO') && u.status === 'ACTIVE') {
                    filtered.push(u)
                }
                return true
            })
            setUsers(filtered)
        })

        getRulesPromise().then(async (response) => {
            setRules(response.data)
        })
    }, []);

    const handlerChange = (menu, field, value, enter) => {
        const obj = {...advancedObj, [field]: value};
        if (value === null || value === "") {
            delete obj[field];
        }
        setAdvancedObj(obj);
        if (enter) {
            let objMenu = advancedObjMenu[menu];
            const obj2 = {...objMenu, [field]: value};
            if (value === null || value === "") {
                delete obj2[field];
            }
            const obj3 = {...advancedObjMenu, [menu]: obj2};

            cbFilters(obj);
            setAdvancedObjMenu(obj3);
        }
    };

    const enterHandler = (menu, field, value) => {
        handlerChange(menu, field, value, true);
    };

    const handleClear = () => {
        setAdvancedObj({});
        setAdvancedObjMenu({m1: {}, m2: {}, m3: {}, m4: {} });
        cbFilters({});
    };

    return (
        <div className="adv-tabs-filters">
                <div className="filters-inner">
                    <Tabs defaultActiveKey={filters.ruleId ? "3" : "1"}>

                        <TabPane key="1"
                                 tab={
                                     <span>
                                    {t('messages.aml.monitor.people') + " "}
                                         <Badge count={Object.entries(advancedObjMenu.m1).length}/>
                                 </span>
                                 }
                        >

                            <Row gutter={4}>

                                <Col span={8}>
                                    <Input
                                        placeholder= {type !== 'EVENTO' ?  t('messages.aml.monitor.rut.name'): t('messages.aml.monitor.rut.name.other') }
                                        value={advancedObj.rutNombre}
                                        onChange={(e) =>
                                            handlerChange("m1", "rutNombre", e.target.value, false)
                                        }
                                        onPressEnter={(e) =>
                                            enterHandler("m1", "rutNombre", e.target.value)
                                        }
                                    />
                                </Col>


                                <Col span={4}>
                                    <Select
                                        allowClear
                                        style={{width: "100%"}}
                                        placeholder={t('messages.aml.personType')}
                                        value={advancedObj.tipoPersona}
                                        onChange={(value) =>
                                            handlerChange("m1", "tipoPersona", value, true)
                                        }
                                    >
                                        <Select.Option value="Entity">
                                            {t("messages.aml.entity")}
                                        </Select.Option>
                                        <Select.Option value="Person">
                                            {t("messages.aml.person")}
                                        </Select.Option>
                                    </Select>
                                </Col>
                            </Row>
                        </TabPane>


                        <TabPane key="2"
                                 tab={
                                     <>
                                    <span>
                                        {t('messages.aml.monitor.alertas') + " "}
                                    </span>
                                         <Badge count={Object.entries(advancedObjMenu.m2).length}/>
                                     </>
                                 }
                        >
                            <Row gutter={4}>

                                <Col span={7}>
                                    <DatePicker.RangePicker
                                        placeholder={[t('messages.aml.monitor.date.reception'), t('messages.aml.to')]}
                                        style={{width: "100%"}}
                                        value={
                                            advancedObj.fechaAlerta
                                                ? [
                                                    moment(advancedObj.fechaAlerta[0]),
                                                    moment(advancedObj.fechaAlerta[1]),
                                                ]
                                                : null
                                        }
                                        onChange={(momentObj) =>
                                            handlerChange(
                                                "m2",
                                                "fechaAlerta",
                                                momentObj !== null && momentObj.length > 0
                                                    ? [
                                                        moment(momentObj[0]).valueOf(),
                                                        moment(momentObj[1]).valueOf(),
                                                    ]
                                                    : null,
                                                true
                                            )
                                        }
                                    />
                                </Col>

                                <Col span={3}>
                                    <Input
                                        placeholder={t('messages.aml.folio')}
                                        style={{width: "100%"}}
                                        value={advancedObj.folio}
                                        onChange={(e) =>
                                            handlerChange("m2", "folio", e.target.value, false)
                                        }
                                        onPressEnter={(e) =>
                                            enterHandler("m2", "folio", e.target.value)
                                        }
                                    />
                                </Col>

                                <Col span={7}>
                                    <DatePicker.RangePicker
                                        placeholder={[t('messages.aml.monitor.date.assignment'), t('messages.aml.to')]}
                                        style={{width: "100%"}}
                                        value={
                                            advancedObj.fechaAsignacion
                                                ? [
                                                    moment(advancedObj.fechaAsignacion[0]),
                                                    moment(advancedObj.fechaAsignacion[1]),
                                                ]
                                                : null
                                        }
                                        onChange={(momentObj) =>
                                            handlerChange(
                                                "m2",
                                                "fechaAsignacion",
                                                momentObj !== null && momentObj.length > 0
                                                    ? [
                                                        moment(momentObj[0]).valueOf(),
                                                        moment(momentObj[1]).valueOf(),
                                                    ]
                                                    : null,
                                                true
                                            )
                                        }
                                    />
                                </Col>

                                <Col span={7}>
                                    <Select
                                        allowClear
                                        style={{width: "100%"}}
                                        placeholder={t('messages.aml.monitor.report.user.assigned')}
                                        value={advancedObj.usuarioAsignado}
                                        onChange={(value) =>
                                            handlerChange("m2", "usuarioAsignado", value, true)
                                        }
                                    >
                                        {users.map((user, index) => (
                                            <Select.Option key={index} value={user.id}>{user.name}</Select.Option>
                                        ))}
                                    </Select>
                                </Col>

                            </Row>
                        </TabPane>

                        <TabPane key="3"
                                 tab={
                                     <span>
                                    {t('messages.aml.rules') + " "}
                                         <Badge count={Object.entries(advancedObjMenu.m3).length}/>
                                </span>
                                 }
                        >
                            <Row gutter={4}>
                                <Col span={4}>
                                    <Select
                                        allowClear
                                        style={{width: "100%"}}
                                        placeholder={t('messages.aml.riskType')}
                                        value={advancedObj.tipoRiesgoRules}
                                        onChange={(value) =>
                                            handlerChange("m3", "tipoRiesgoRules", value, true)
                                        }
                                    >
                                        {type !== "EVENTO" && currentUser.cliente.modules.includes('MONITOR-T') &&
                                            <Select.Option value="DEMOGRAFICA">{t('messages.aml.monitor.alertas.DEMOGRAFICA')}</Select.Option>}
                                        {type === "EVENTO" &&
                                            <Select.Option value="EVENTO">{t('messages.aml.compliance')}</Select.Option>}
                                        {type !== "EVENTO" && currentUser.cliente.modules.includes('MONITOR-T') &&
                                            <Select.Option value="TRANSACCIONAL">{t('messages.aml.monitor.alertas.TRANSACCIONAL')}</Select.Option>}
                                        {type !== "EVENTO" && <Select.Option value="PERSONA">{t('messages.aml.monitor.alertas.PERSONA')}</Select.Option>}
                                    </Select>
                                </Col>

                                <Col span={7}>
                                    <Select
                                        allowClear
                                        style={{width: "100%"}}
                                        placeholder={t('messages.aml.rule')}
                                        value={rules && advancedObj.ruleId}
                                        onChange={(value) =>
                                            handlerChange("m3", "ruleId", value, true)
                                        }
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 }
                                    >
                                        {rules && rules.filter(rule => {
                                            if (advancedObj.ruleId != null && rule.id === advancedObj.ruleId) return true
                                            return advancedObj.tipoRiesgoRules === undefined ? rule : rule.type === advancedObj.tipoRiesgoRules
                                        }).map((rule) => {
                                            return (
                                                <Select.Option key={rule.id} value={rule.id}>{rule.name}</Select.Option>
                                            )
                                        })}
                                    </Select>
                                </Col>

                                {
                                    advancedObj.tipoRiesgoRules === "TRANSACCIONAL" &&
                                    <>
                                        <Col span={5}>
                                            <Input
                                                placeholder={t('messages.aml.monitor.transaction.number')}
                                                value={advancedObj.transactionNumber}
                                                onChange={(e) =>
                                                    handlerChange("m3", "transactionNumber", e.target.value, false)
                                                }
                                                onPressEnter={(e) =>
                                                    enterHandler("m3", "transactionNumber", e.target.value)
                                                }
                                            />
                                        </Col>

                                        <Col span={8}>
                                            <DatePicker.RangePicker
                                                placeholder={[t('messages.aml.monitor.date.transaction'), t('messages.aml.to')]}
                                                style={{width: "100%"}}
                                                value={
                                                    advancedObj.fechaTransaction
                                                        ? [
                                                            moment(advancedObj.fechaTransaction[0]),
                                                            moment(advancedObj.fechaTransaction[1]),
                                                        ]
                                                        : null
                                                }
                                                onChange={(momentObj) =>
                                                    handlerChange(
                                                        "m3",
                                                        "fechaTransaction",
                                                        momentObj !== null && momentObj.length > 0
                                                            ? [
                                                                moment(momentObj[0]).valueOf(),
                                                                moment(momentObj[1]).valueOf(),
                                                            ]
                                                            : null,
                                                        true
                                                    )
                                                }
                                            />
                                        </Col>
                                    </>
                                }
                            </Row>
                        </TabPane>


                        {type !== "EVENTO" &&
                            <TabPane
                                key="4"
                                tab={
                                    <span>
                                    {t('messages.aml.register.filter.nameMatches') + " "}
                                        <Badge count={Object.entries(advancedObjMenu.m4).length}/>
                                </span>
                                }
                            >
                                <Row gutter={4}>
                                    <Col span={5}>
                                        <Select
                                            allowClear
                                            style={{width: "100%"}}
                                            placeholder={t('messages.aml.register.filter.hasMatches')}
                                            value={advancedObj.hasFP}
                                            onChange={(value) =>
                                                handlerChange("m4", "hasFP", value, true)
                                            }
                                        >
                                            <Select.Option value="YES">{t('messages.aml.monitor.has.matches.yes')}</Select.Option>
                                            <Select.Option value="NO">{t('messages.aml.monitor.has.matches.no')}</Select.Option>
                                        </Select>
                                    </Col>
                                </Row>
                            </TabPane>
                        }

                    </Tabs>


                    <Tooltip title={t('messages.aml.cdi.advanced.clearFilters')}>
                        <Button
                            icon="delete"
                            className="btn-clear"
                            shape="circle"
                            theme="filled"
                            ghost
                            onClick={handleClear}
                        />
                    </Tooltip>
                </div>
        </div>

    );
};

export default AdvancedTabs;
